<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Shipments_Title' | translateWF: 'Shipments' }}
        </h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails()" />
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Shipments_Title' | translateWF: 'Shipments'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listShipments()" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" selectionMode="single" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr class="cs-datatable-header-dark">
                <th pSortableColumn="shipmentNumber">
                  {{ 'Shipments_Shipment_Number' | translateWF: 'Shipment Number' }}
                  <p-sortIcon field="shipmentNumber"></p-sortIcon>
                </th>
                <th>{{ 'Shipments_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Shipments_Tracking_Number' | translateWF: 'Tracking Number' }}</th>
                <th>{{ 'Shipments_Invoices' | translateWF: 'Invoices/Delivery Notes' }}</th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let shipment = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(shipment.id)">
                <td>
                  <a>{{ shipment.shipmentNumber }}</a>
                </td>
                <td>{{ statuses()[shipment.status] }}</td>
                <td>{{ shipment.trackingNumber }}</td>
                <td>
                  @if (getInvoices(shipment)) {
                    <div>{{ getInvoices(shipment) }}</div>
                  }
                  @if (getDeliveryNotes(shipment)) {
                    <div>{{ getDeliveryNotes(shipment) }}</div>
                  }
                  @if (!getInvoices(shipment) && !getDeliveryNotes(shipment)) {
                    <span>-</span>
                  }
                </td>
                <td></td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  {{ 'Shipments_Not_Found' | translateWF: 'Shipments not found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            dropdownAppendTo="body"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
